var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.8999L10.1931 4.0725C10.923 8.50376 14.3962 11.9769 18.8274 12.7068L20 12.8999L18.8274 13.093C14.3961 13.8229 10.923 17.2961 10.1931 21.7273L10 22.8999L9.80686 21.7273C9.07695 17.296 5.60386 13.8229 1.1726 13.093L0 12.8999L1.1726 12.7068C5.60386 11.9769 9.07695 8.50376 9.80686 4.0725L10 2.8999Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d372f5e7d045089860ea21aeb8613561.svg";
export { ForwardRef as ReactComponent };